import { useEffect, useState } from 'react'

import { useDispatch } from 'react-redux'
import { checkPDFSettings } from 'store/Course/actions'
import './style.css'
import { getPdfjsUrl } from 'utils/helpers'
import { useSelector } from 'react-redux'
import PdfReader from './PdfReader'
/*eslint-disable */
export default (props) => {
  const { iFrameKey } = useSelector((state) => state.courses)

  const generalConfig = useSelector((state) => state.generalConfig)
  const [fullUrl, setFullUrl] = useState('')
  const [pdfjsUrl, setPdsjsUrl] = useState(
    window.location.hostname.startsWith('pollozone')
      ? 'https://d2x2yurzgc1veb.cloudfront.net/pollozone-pdfjs/pdfjs/web/viewer.html?file='
      : 'https://d2x2yurzgc1veb.cloudfront.net/pdfjs/web/viewer.html?file='
  )
  const [googleUrl, setGoogleUrl] = useState(
    'https://docs.google.com/gview?url='
  )

  const dispatch = useDispatch()
  console.log('dispatch(checkPDFSettings()) ', dispatch(checkPDFSettings()))
  console.log('leart25', props)
  useEffect(() => {
    const full_url =
      props.contentType == 'application/pdf' &&
      dispatch(checkPDFSettings()) == 'pdfjs'
        ? `${pdfjsUrl}${props.url}&embedded=true`
        : `${googleUrl}${props.url}&embedded=true`

    setFullUrl(full_url)
  }, [props])

  useEffect(() => {
    const full_url =
      props.contentType == 'application/pdf' &&
      dispatch(checkPDFSettings()) == 'pdfjs'
        ? `${getPdfjsUrl(generalConfig.pdfjsDownloadAndPrint)}${
            props.url
          }&embedded=true`
        : `${googleUrl}${props.url}&embedded=true`

    setFullUrl(full_url)
  }, [])

  let pdfJsView = dispatch(checkPDFSettings()) === 'pdfjs' ? true : false

  // PDFs on the pdf.js setting are drawn inside the app (no download or print
  // buttons, same look in every browser and on phones).
  if (props.contentType == 'application/pdf' && pdfJsView) {
    return <PdfReader key={iFrameKey} url={props.url} title={props.name} />
  }

  return props.disablePdfDownload === 0 ? (
    <iframe
      key={iFrameKey}
      id={
        (!pdfJsView && window.location.hostname.startsWith('kiwi-release')) ||
        (!pdfJsView && window.location.hostname.startsWith('kitopi'))
          ? 'iframe'
          : ''
      }
      src={`${fullUrl}&nocache=${iFrameKey}`}
      style={{
        width: props.url ? '100%' : '0',
        height: props.url ? '100%' : '0',
      }}
      frameBorder='0'
      sandbox='allow-forms allow-downloads allow-modals allow-pointer-lock allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation'
    ></iframe>
  ) : (
    <iframe
      key={iFrameKey}
      id={
        (!pdfJsView && window.location.hostname.startsWith('kiwi-release')) ||
        (!pdfJsView && window.location.hostname.startsWith('kitopi'))
          ? 'iframe'
          : ''
      }
      className='disable'
      sandbox='allow-forms allow-downloads allow-modals allow-pointer-lock allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation allow-scripts'
      src={fullUrl}
      style={{
        width: props.url ? '100%' : '0',
        height: props.url ? '100%' : '0',
      }}
      frameBorder='0'
    ></iframe>
  )
}
